/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Payout admin
 * Payout application
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import {
    type DataTag,
    type DefinedInitialDataOptions,
    type DefinedUseQueryResult,
    type QueryClient,
    type QueryFunction,
    type QueryKey,
    type UndefinedInitialDataOptions,
    type UseQueryOptions,
    type UseQueryResult,
} from '@tanstack/react-query';
import { payoutKyMutator } from '../../shared/api/kyMutator';
import { type ErrorType, type BodyType } from '../../shared/api/kyMutator';
import {
    type AdminPayoutTicketServiceCountTicketsParams,
    type AdminPayoutTicketServiceListTicketsParams,
    type GoogleRpcStatus,
    type PayoutAdminTicketV1CountTicketsResponse,
    type PayoutAdminTicketV1ListTicketsResponse,
    type PayoutAdminTicketV1ResolveTicketRequest,
    type PayoutAdminTicketV1ResolveTicketResponse,
} from './model';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };

    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === 'queryKey') {
            continue;
        }

        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }

    return result;
};

export const getAdminPayoutTicketServiceCountTicketsUrl = (params?: AdminPayoutTicketServiceCountTicketsParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ['filter.statuses', 'filter.priorities'];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });

            return;
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/ticket/count?${stringifiedParams}` : '/v1/ticket/count';
};

/**
 * @summary Requires tickets.read.
 */
export const adminPayoutTicketServiceCountTickets = async (
    params?: AdminPayoutTicketServiceCountTicketsParams,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminTicketV1CountTicketsResponse> => {
    return payoutKyMutator<PayoutAdminTicketV1CountTicketsResponse>(
        getAdminPayoutTicketServiceCountTicketsUrl(params),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getAdminPayoutTicketServiceCountTicketsQueryKey = (
    params?: AdminPayoutTicketServiceCountTicketsParams,
) => {
    return ['/v1/ticket/count', ...(params ? [params] : [])] as const;
};

export const getAdminPayoutTicketServiceCountTicketsQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutTicketServiceCountTickets>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTicketServiceCountTicketsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTicketServiceCountTickets>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayoutTicketServiceCountTicketsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutTicketServiceCountTickets>>> = ({ signal }) =>
        adminPayoutTicketServiceCountTickets(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutTicketServiceCountTickets>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutTicketServiceCountTicketsQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutTicketServiceCountTickets>>
>;
export type AdminPayoutTicketServiceCountTicketsQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutTicketServiceCountTickets<
    TData = Awaited<ReturnType<typeof adminPayoutTicketServiceCountTickets>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayoutTicketServiceCountTicketsParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTicketServiceCountTickets>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTicketServiceCountTickets>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTicketServiceCountTickets>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTicketServiceCountTickets<
    TData = Awaited<ReturnType<typeof adminPayoutTicketServiceCountTickets>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTicketServiceCountTicketsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTicketServiceCountTickets>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTicketServiceCountTickets>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTicketServiceCountTickets>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTicketServiceCountTickets<
    TData = Awaited<ReturnType<typeof adminPayoutTicketServiceCountTickets>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTicketServiceCountTicketsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTicketServiceCountTickets>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires tickets.read.
 */

export function useAdminPayoutTicketServiceCountTickets<
    TData = Awaited<ReturnType<typeof adminPayoutTicketServiceCountTickets>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTicketServiceCountTicketsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTicketServiceCountTickets>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutTicketServiceCountTicketsQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutTicketServiceListTicketsUrl = (params?: AdminPayoutTicketServiceListTicketsParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ['filter.statuses', 'filter.priorities'];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });

            return;
        }

        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/tickets?${stringifiedParams}` : '/v1/tickets';
};

/**
 * @summary Requires tickets.read.
 */
export const adminPayoutTicketServiceListTickets = async (
    params?: AdminPayoutTicketServiceListTicketsParams,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminTicketV1ListTicketsResponse> => {
    return payoutKyMutator<PayoutAdminTicketV1ListTicketsResponse>(getAdminPayoutTicketServiceListTicketsUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getAdminPayoutTicketServiceListTicketsQueryKey = (params?: AdminPayoutTicketServiceListTicketsParams) => {
    return ['/v1/tickets', ...(params ? [params] : [])] as const;
};

export const getAdminPayoutTicketServiceListTicketsQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutTicketServiceListTickets>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTicketServiceListTicketsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTicketServiceListTickets>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayoutTicketServiceListTicketsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutTicketServiceListTickets>>> = ({ signal }) =>
        adminPayoutTicketServiceListTickets(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutTicketServiceListTickets>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutTicketServiceListTicketsQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutTicketServiceListTickets>>
>;
export type AdminPayoutTicketServiceListTicketsQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutTicketServiceListTickets<
    TData = Awaited<ReturnType<typeof adminPayoutTicketServiceListTickets>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayoutTicketServiceListTicketsParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTicketServiceListTickets>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTicketServiceListTickets>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTicketServiceListTickets>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTicketServiceListTickets<
    TData = Awaited<ReturnType<typeof adminPayoutTicketServiceListTickets>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTicketServiceListTicketsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTicketServiceListTickets>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTicketServiceListTickets>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTicketServiceListTickets>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTicketServiceListTickets<
    TData = Awaited<ReturnType<typeof adminPayoutTicketServiceListTickets>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTicketServiceListTicketsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTicketServiceListTickets>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires tickets.read.
 */

export function useAdminPayoutTicketServiceListTickets<
    TData = Awaited<ReturnType<typeof adminPayoutTicketServiceListTickets>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTicketServiceListTicketsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTicketServiceListTickets>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutTicketServiceListTicketsQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutTicketServiceResolveTicketUrl = () => {
    return '/v1/tickets/resolve';
};

/**
 * @summary Requires tickets.resolve.
 */
export const adminPayoutTicketServiceResolveTicket = async (
    payoutAdminTicketV1ResolveTicketRequest: PayoutAdminTicketV1ResolveTicketRequest,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminTicketV1ResolveTicketResponse> => {
    return payoutKyMutator<PayoutAdminTicketV1ResolveTicketResponse>(getAdminPayoutTicketServiceResolveTicketUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payoutAdminTicketV1ResolveTicketRequest),
    });
};

export const getAdminPayoutTicketServiceResolveTicketQueryKey = (
    payoutAdminTicketV1ResolveTicketRequest?: BodyType<PayoutAdminTicketV1ResolveTicketRequest>,
) => {
    return ['POST', '/v1/tickets/resolve', payoutAdminTicketV1ResolveTicketRequest] as const;
};

export const getAdminPayoutTicketServiceResolveTicketQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutTicketServiceResolveTicket>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTicketV1ResolveTicketRequest: BodyType<PayoutAdminTicketV1ResolveTicketRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTicketServiceResolveTicket>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getAdminPayoutTicketServiceResolveTicketQueryKey(payoutAdminTicketV1ResolveTicketRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutTicketServiceResolveTicket>>> = ({ signal }) =>
        adminPayoutTicketServiceResolveTicket(payoutAdminTicketV1ResolveTicketRequest, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutTicketServiceResolveTicket>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutTicketServiceResolveTicketQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutTicketServiceResolveTicket>>
>;
export type AdminPayoutTicketServiceResolveTicketQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutTicketServiceResolveTicket<
    TData = Awaited<ReturnType<typeof adminPayoutTicketServiceResolveTicket>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTicketV1ResolveTicketRequest: BodyType<PayoutAdminTicketV1ResolveTicketRequest>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTicketServiceResolveTicket>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTicketServiceResolveTicket>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTicketServiceResolveTicket>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTicketServiceResolveTicket<
    TData = Awaited<ReturnType<typeof adminPayoutTicketServiceResolveTicket>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTicketV1ResolveTicketRequest: BodyType<PayoutAdminTicketV1ResolveTicketRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTicketServiceResolveTicket>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTicketServiceResolveTicket>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTicketServiceResolveTicket>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTicketServiceResolveTicket<
    TData = Awaited<ReturnType<typeof adminPayoutTicketServiceResolveTicket>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTicketV1ResolveTicketRequest: BodyType<PayoutAdminTicketV1ResolveTicketRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTicketServiceResolveTicket>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires tickets.resolve.
 */

export function useAdminPayoutTicketServiceResolveTicket<
    TData = Awaited<ReturnType<typeof adminPayoutTicketServiceResolveTicket>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTicketV1ResolveTicketRequest: BodyType<PayoutAdminTicketV1ResolveTicketRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTicketServiceResolveTicket>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutTicketServiceResolveTicketQueryOptions(
        payoutAdminTicketV1ResolveTicketRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}
